import { Stack, Text } from "@chakra-ui/react";
import React from "react";
import { BsQuote } from "react-icons/bs";

const Testimonial = ({ review, name }) => {
  return (
    <>
      <Stack
        textAlign="left"
        color="#fff"
        width={{ base: "2xs", md: "xl", lg: "3xl" }}
        m="auto"
        gap="6"
      >
        <BsQuote size="50" />
        <Text fontSize={{ base: "sm", md: "2xl" }} fontWeight="semibold">
          {review}
        </Text>
        <Stack gap="0">
          <Text>--</Text>
          <Text fontWeight="500">{name}</Text>
        </Stack>
      </Stack>
    </>
  );
};

export default Testimonial;
